import { FormControlLabel, FormGroup, Typography } from '@mui/material';
import _ from 'lodash';
import Checkbox from '@mui/material/Checkbox';
import React from 'react';

function CheckBoxFormHook(props: any) {
  const importedProps = _.pick(props, [
    'checked',
    'checkedIcon',
    'classes',
    'className',
    'color',
    'defaultChecked',
    'disabled',
    'disableRipple',
    'icon',
    'id',
    'indeterminate',
    'indeterminateIcon',
    'inputProps',
    'inputRef',
    'onChange',
    'required',
    'size',
    'sx',
    'value',
    'label'
  ]);

  const { errorMessage, register, options, name, hideErrorMessage, onChange } = props;
  return (
    <>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox {...importedProps} {...register(name, options)} onChange={(event: any) => onChange(event)} />
          }
          label={props.label}
        />
      </FormGroup>

      {errorMessage && !hideErrorMessage && (
        <Typography variant="inherit" className="text-red-500">
          {errorMessage}
        </Typography>
      )}
    </>
  );
}

export default React.memo(CheckBoxFormHook);
